/**
 * paneTypography — the THREE text styles the Outlook pane's surfaces use
 * (story 28633: "at max 3 different variations ... each additional font and
 * style drives perceived complexity").
 *
 *   TYPE_TITLE — 13px semibold: a subject, a client name, a button label.
 *   TYPE_BODY  — 12px regular: everything a person reads as a sentence.
 *   TYPE_LABEL — 10px semibold uppercase: section headings and small labels.
 *
 * Size, weight, leading and case only — NO colour, so a caller adds exactly
 * one `text-<colour>` class and never has two competing. Roboto throughout
 * (font-sans); the brand lockup in `WorkflowCenterBar` and colour-coded status
 * pills are components, not text styles, and keep their own look.
 *
 * Shared — no Office.js, no Remix import.
 */

export const TYPE_TITLE = "text-[13px] font-semibold leading-[19px]";
export const TYPE_BODY = "text-xs font-normal leading-[18px]";
export const TYPE_LABEL = "text-[10px] font-semibold uppercase leading-[14px] tracking-[0.07em]";

/**
 * The pane's primary action — Review & Approve's exact look (sunrise fill,
 * full width, TYPE_TITLE label). Any button that should read as "the thing to
 * click" uses this, so two of them can never drift apart.
 */
export const PRIMARY_ACTION_BUTTON_CLASS =
  "flex w-full items-center justify-center gap-2 rounded-md bg-sunrise px-3 py-2.5 text-[13px] font-semibold leading-[19px] text-primary-gray-light-900 disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-sunrise";
